import { BriefcaseBusinessIcon, MapPinIcon } from "lucide-react";

import { locations } from "@/lib/locations";
import { misc } from "@/lib/misc";
import { Profile } from "@/types";

export const SheetHeader = ({ profile }: { profile: Profile }) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex h-[80px] w-[80px] items-center justify-center rounded-full bg-primary-900">
        <p className="text-xl font-semibold text-white">
          {/* TODO: Handle null first and/or last name? */}
          {misc.toTitleCase(profile.firstName?.[0] ?? "")}
          {misc.toTitleCase(profile.lastName?.[0] ?? "")}
        </p>
      </div>
      <div>
        <p className="text-2xl font-semibold text-slate-700">
          {misc.toTitleCase(
            `${profile.firstName ?? ""} ${profile.lastName ?? ""}`,
          )}
        </p>
        <div className="flex items-center gap-1">
          {profile.desiredPosition && (
            <>
              <BriefcaseBusinessIcon
                // Looks more aligned with the 2px of margin on the bottom.
                className="mb-[2px] h-4 w-4 text-slate-500"
              />
              <p className="font-medium text-slate-500">
                {profile.desiredPosition}
              </p>
              {/*
               * There are a near-zero amount of profiles that do not have a location.
               * Therefore, if there is a desired position, we can safely add the "•".
               */}
              <p className="leading-none text-slate-500">•</p>
            </>
          )}
          <div className="flex items-center gap-[2px]">
            <MapPinIcon
              // Looks more aligned with the 2px of margin on the bottom.
              className="mb-[2px] h-4 w-4 text-slate-500"
            />
            <p className="font-medium text-slate-500">
              {locations.stripCountrySuffix(profile.location ?? "")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
